import React from 'react';
import { VerifyOrReverifyEmailError } from '../types';
import VerifyOrReverifyEmailExpiredTokenErrorPage from './VerifyOrReverifyEmailExpiredTokenErrorPage';
import VerifyOrReverifyEmailRateLimitExceededErrorPage from './VerifyOrReverifyEmailRateLimitExceededErrorPage';
import VerifyOrReverifyEmailInvalidTokenErrorPage from './VerifyOrReverifyEmailInvalidTokenErrorPage';
import { useAppSelector } from '../stores/redux.store';
import { fetchPageState } from '../utilities/hooks/useGlobalPageState';
import { AidFrontendFeatureGate } from '../providers/FeatureGates';
import { checkFeatureGateOnceInitialized } from '../utilities/feature-flags/feature-gate';

export async function verifyEmailLoader({ request }: { request: Request }) {
  if (!(await checkFeatureGateOnceInitialized(AidFrontendFeatureGate.USE_STATE_DATA_LOADERS))) {
    return null;
  }

  return await fetchPageState('/rest/verify-email/state', request, {
    capabilities: ['capability-group--login', 'capability-name--mfa'],
  });
}

export const VerifyOrReverifyEmailErrorPage = () => {
  const { error, url, verificationType } = useAppSelector(state => state.verifyEmail);

  switch (error) {
    case VerifyOrReverifyEmailError.ExpiredToken:
      return (
        <VerifyOrReverifyEmailExpiredTokenErrorPage
          recoverUrl={url}
          verificationType={verificationType}
        />
      );
    case VerifyOrReverifyEmailError.InvalidToken:
      return (
        <VerifyOrReverifyEmailInvalidTokenErrorPage
          recoverUrl={url}
          verificationType={verificationType}
        />
      );
    case VerifyOrReverifyEmailError.RateLimitExceeded:
      return (
        <VerifyOrReverifyEmailRateLimitExceededErrorPage
          recoverUrl={url}
          verificationType={verificationType}
        />
      );
    default:
      return null;
  }
};

export default VerifyOrReverifyEmailErrorPage;
